var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_16448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 31.6667,
    height: 31.6667,
    rx: 15.8333,
    fill: "#1976D2",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0832 7.91663H11.7498C10.879 7.91663 10.1744 8.62913 10.1744 9.49996L10.1665 22.1666C10.1665 23.0375 10.8711 23.75 11.7419 23.75H21.2498C22.1207 23.75 22.8332 23.0375 22.8332 22.1666V12.6666L18.0832 7.91663ZM21.2498 22.1666H11.7498V9.49996H17.2915V13.4583H21.2498V22.1666ZM13.3332 18.2162L14.4494 19.3325L15.7082 18.0816V21.375H17.2915V18.0816L18.5503 19.3404L19.6665 18.2162L16.5078 15.0416L13.3332 18.2162Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_16448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6667,
    height: 31.6667,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.8c4daacf1fa0ec61d002429b99401b64.svg";
export { ForwardRef as ReactComponent };